import { render } from "./UiImageZoomer.vue?vue&type=template&id=553e2722&scoped=true"
import script from "./UiImageZoomer.vue?vue&type=script&lang=js"
export * from "./UiImageZoomer.vue?vue&type=script&lang=js"

import "./UiImageZoomer.vue?vue&type=style&index=0&id=553e2722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553e2722"]])

export default __exports__